function Line() {
  return (
    <hr className="bg-primary mx-auto h-[.25rem] w-[4.1875rem] content-center border-0"></hr>
  )
}

export { Line }
